import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ApiCallService } from "../../../api/service/api-call.service";
import * as Constants from "../../../constant/Constants";
import { ActivatedRoute } from "@angular/router";
import { ValidationService } from "src/app/services/validation.service";
import { environment } from "src/environments/environment";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";

@Component({
  selector: "app-claim-details",
  templateUrl: "./claim-details.component.html",
  styleUrls: ["./claim-details.component.css"],
})
export class ClaimDetailsComponentUG implements OnInit {
  // Url Params
  claim: string = "accident"; // theft, fire, accident ... etc.
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  pageHeading: string = "Claim Application";
  pageSubheading: string = "Vehicle Details";

  // vehicleRegLabel: string = "Enter vehicle's registration number";
  ownerNameLabel: string = "Enter car owner's name";
  theftDateLabel: string = "Date of accident";
  theftTimeLabel: string = "Time of accident";
  theftLocationLabel: string = "Location of accident";

  thirdPartyQuestion: string = "Was a third party involved?";
  policeNotifiedQuestion: string = "Has the police been notified?";

  yesText: string = "Yes";
  noText: string = "No";

  cancel: string = "Cancel";
  saveContinue: string = "Save and Continue";

  motorForm = this._formBuilder.group({
    // vehicleReg: ["", Validators.required],
    ownerName: ["", Validators.required],
    theftDate: ["", Validators.required],
    theftTime: ["", Validators.required],
    theftLocation: ["", Validators.required],

    thirdParty: this._formBuilder.group({
      yes: false,
      no: false,
    }),

    policeNotified: this._formBuilder.group({
      yes: false,
      no: false,
    }),
  });

  minDate: Date;
  maxDate: Date;
  formGroupErrors: { [key: string]: string } = {
    thirdParty: "",
    policeNotified: "",
  };
  formErrors: { [key: string]: string } = {
    // vehicleReg: "",
    ownerName: "",
    theftDate: "",
    theftTime: "",
    theftLocation: "",
  };
  validationMessages: { [key: string]: { [key: string]: string } } = {
    // vehicleReg: { required: "vehicle registration is required" },
    ownerName: { required: "This field is required" },
    theftDate: { required: "This field is required" },
    theftTime: { required: "This field is required" },
    theftLocation: { required: "This field is required" },
    thirdParty: { required: "You must select one option to continue" },
    policeNotified: { required: "You must select one option to continue" },
  };

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private apiCallService: ApiCallService,
    private validationService: ValidationService,
    public dialog: MatDialog
  ) {
    const currentDate = new Date();
    const tempDate = new Date(currentDate.getTime());

    tempDate.setFullYear(currentDate.getFullYear() - 1);
    this.minDate = tempDate;
    this.maxDate = currentDate;
  }

  loading: boolean = false;
  url: string = environment.baseUrl + Constants.claimUG_URL;

  ngOnInit(): void {
    this.validationService.subcribeToControlChanges(
      "thirdParty",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "policeNotified",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );

    this.motorForm.valueChanges.subscribe((form) => {
      this.logErrors();

      if (form.ownerName) {
        this.motorForm.patchValue({
          ownerName: form.ownerName.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.theftLocation) {
        this.motorForm.patchValue({
          theftLocation: form.theftLocation.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
    });

    this.route.queryParams.subscribe((params) => {
      if (params["token"] !== undefined) {
        this.token = params["token"];
      }

      if (params["claim"] !== undefined) {
        this.claim = params["claim"];

        if (params["claim"] === "theft") {
          this.theftDateLabel = "Date of theft";
          this.theftTimeLabel = "Time of theft";
          this.theftLocationLabel = "Location of theft";
        } else if (params["claim"] === "fire") {
          this.theftDateLabel = "Date of fire";
          this.theftTimeLabel = "Time of fire";
          this.theftLocationLabel = "Location of fire";
        }
      }
    });
  }
  logErrors() {
    this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };
  
  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      classCode: "970",
      // vehicleReg: this.motorForm.controls["vehicleReg"].value,
      ownerName: this.motorForm.controls["ownerName"].value,
      date: this.motorForm.controls["theftDate"].value,
      time: this.motorForm.controls["theftTime"].value,
      location: this.motorForm.controls["theftLocation"].value,
      thirdParty: this.motorForm.controls["thirdParty"].controls["yes"].value === true ? 'Yes' : 'No',
      policeNotified: this.motorForm.controls["policeNotified"].controls["yes"].value === true ? 'Yes' : 'No',
      token: this.token,
      filled: true,
    };

    try {
      // Update form data (POST)
      const response = await this.apiCallService.postRequest(
        `${this.url}?token=${this.token}`, req
      ); // url to change for UG?
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL_UG;
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'This will cancel the claim application. Are you sure you want to proceed?',
      'Back',
      'CONTINUE'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL_UG;
        
      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL_UG;
    }
  }

  onYesChange() {
    this.motorForm.controls["thirdParty"].controls["no"].setValue(false);
  }

  onNoChange() {
    this.motorForm.controls["thirdParty"].controls["yes"].setValue(false);
  }

  onYes2Change() {
    this.motorForm.controls["policeNotified"].controls["no"].setValue(false);
  }

  onNo2Change() {
    this.motorForm.controls["policeNotified"].controls["yes"].setValue(false);
  }
}
